import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { VesselsService } from 'src/app/services/vessels.service';
@Component({
  selector: 'app-add-ship-point',
  templateUrl: './add-ship-point.component.html',
  styleUrls: ['./add-ship-point.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddShipPointComponent implements OnInit {
  searchText: string = '';
  pointsForm: UntypedFormGroup;
  pointsFormvalue:any;
  // ispointError:boolean = false;
  // isscrubberError:boolean = false;
  // errorMessage:string = '';
  @Output() getPointsform = new EventEmitter<any>();
  // private readonly decimalPattern = /^\d{1,3}(\.\d{0,2})?$/;

  //  private readonly decimalPattern = /^[1-9]\d*(?:\.\d{1,2})?$/;
  private readonly decimalPattern = /^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/;
  

 
  
  
  //  private readonly decimalPattern = '^(?!0+(\.0+)?$)\d{1,3}(\.\d{1,2})?$';
  showScrubber: boolean = false;
  showPointsErrorMsg: boolean = false;
  showScrubberErrorMsg: boolean = false;

  constructor( private fb: UntypedFormBuilder, private vesselService:VesselsService) {
  }
  // @HostListener('focusout')
  // focusOutHandler() {
  //   this.showPointsErrorMsg = true;
  // }
  
  handleFocusOutScrubber(e:any){
    console.log(e)
    this.showScrubberErrorMsg = true;
  }
  handleFocusOutPoints(e:any){
     console.log(e)
    this.showPointsErrorMsg = true;
  }

  ngOnInit() {
    
    console.log(this.vesselService.scrubberToggleval)
    if(this.vesselService.scrubberToggleval){
      this.showScrubber = this.vesselService.scrubberToggleval;
       this.pointsForm = this.fb.group({
        points: ['', [Validators.required,Validators.pattern(this.decimalPattern)]],
        scrubberPoints:['', [Validators.required,Validators.pattern(this.decimalPattern)]]
      });
    }else{
       this.pointsForm = this.fb.group({
        points: ['', [Validators.required,Validators.pattern(this.decimalPattern)]],
      });
    }
    
    if (this.vesselService.pointsVal || this.vesselService.scrubberPointsval) {
      this.pointsForm.patchValue(this.vesselService.pointsVal);
      this.pointsForm.patchValue(this.vesselService.scrubberPointsval);
    }
    this.pointsForm.valueChanges.subscribe((value:any) => {
      this.vesselService.pointsVal = value;
      this.vesselService.scrubberPointsval = value;
      console.log(this.vesselService.pointsVal)
      console.log(this.vesselService.scrubberPointsval)
    });
    console.log(this.vesselService.pointsVal)
    console.log(this.vesselService.scrubberPointsval)
    console.log( this.pointsForm)
   
    this.getPointsform.emit(this.pointsForm)
  }
 
}